/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `not_started` - Not Started
 * * `in_progress` - In Progress
 * * `completed` - Completed
 * * `expired` - Expired
 * @export
 */
export const OnboardingStatusEnum = {
    NotStarted: 'not_started',
    InProgress: 'in_progress',
    Completed: 'completed',
    Expired: 'expired'
} as const;
export type OnboardingStatusEnum = typeof OnboardingStatusEnum[keyof typeof OnboardingStatusEnum];


export function instanceOfOnboardingStatusEnum(value: any): boolean {
    for (const key in OnboardingStatusEnum) {
        if (Object.prototype.hasOwnProperty.call(OnboardingStatusEnum, key)) {
            if (OnboardingStatusEnum[key as keyof typeof OnboardingStatusEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OnboardingStatusEnumFromJSON(json: any): OnboardingStatusEnum {
    return OnboardingStatusEnumFromJSONTyped(json, false);
}

export function OnboardingStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): OnboardingStatusEnum {
    return json as OnboardingStatusEnum;
}

export function OnboardingStatusEnumToJSON(value?: OnboardingStatusEnum | null): any {
    return value as any;
}

export function OnboardingStatusEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): OnboardingStatusEnum {
    return value as OnboardingStatusEnum;
}

